import getConfig from 'next/config'
import NodeRSA from 'node-rsa'
import { MOBILE_APP_EVENTS } from './constant'

const rsaPublicKey = getConfig().publicRuntimeConfig.rsaPublicKey

declare global {
  interface Window {
    webkit?: {
      messageHandlers: {
        iOSHandler: {
          postMessage: (message: any) => void
        }
      }
    }
    handleiOSMessage?: (message: any) => void
  }
}

export const toDictionary = <T, K>(
  arr: T[],
  keyFn: (item: T) => string,
  itemFn: (item: T) => K
) => {
  return arr.reduce((total, item) => {
    total[keyFn(item)] = itemFn(item)
    return total
  }, {} as { [key: string]: K })
}

export const rsaEncryptData = (data: any) => {
  if (typeof window !== 'undefined') {
    try {
      const publicKey = new NodeRSA(rsaPublicKey, 'pkcs8-public')
      return publicKey.encrypt(data, 'base64')
    } catch (err: any) {
      console.error(err)
      return ''
    }
  }
  return ''
}

export const mappingStateCode = {
  alabama: 'al',
  alaska: 'ak',
  americansamoa: 'as',
  arizona: 'az',
  arkansas: 'ar',
  california: 'ca',
  colorado: 'co',
  connecticut: 'ct',
  delaware: 'de',
  districtofcolumbia: 'dc',
  federatedstatesofmicronesia: 'fm',
  florida: 'fl',
  georgia: 'ga',
  guam: 'gu',
  hawaii: 'hi',
  idaho: 'id',
  illinois: 'il',
  indiana: 'in',
  iowa: 'ia',
  kansas: 'ks',
  kentucky: 'ky',
  louisiana: 'la',
  maine: 'me',
  marshallislands: 'mh',
  maryland: 'md',
  massachusetts: 'ma',
  michigan: 'mi',
  minnesota: 'mn',
  mississippi: 'ms',
  missouri: 'mo',
  montana: 'mt',
  nebraska: 'ne',
  nevada: 'nv',
  newhampshire: 'nh',
  newjersey: 'nj',
  newmexico: 'nm',
  newyork: 'ny',
  northcarolina: 'nc',
  northdakota: 'nd',
  northernmarianaislands: 'mp',
  ohio: 'oh',
  oklahoma: 'ok',
  oregon: 'or',
  palau: 'pw',
  pennsylvania: 'pa',
  puertorico: 'pr',
  rhodeisland: 'ri',
  southcarolina: 'sc',
  southdakota: 'sd',
  tennessee: 'tn',
  texas: 'tx',
  utah: 'ut',
  vermont: 'vt',
  virginislands: 'vi',
  virginia: 'va',
  washington: 'wa',
  westvirginia: 'wv',
  wisconsin: 'wi',
  wyoming: 'wy'
}

interface IAppMessage {
  type: keyof typeof MOBILE_APP_EVENTS
  payload?: {
    sellpage_id?: string
    [y: string]: any
  }
  [x: string]: any
}

export function sendMessageToApp(message: IAppMessage) {
  if (
    window.webkit &&
    window.webkit?.messageHandlers &&
    window.webkit?.messageHandlers?.iOSHandler
  ) {
    window.webkit.messageHandlers.iOSHandler.postMessage(JSON.stringify(message))
  } else {
    console.log('Not in iOS WebView or handler not available')
  }
}

export function decodeJSONParameter<T = any>(value: string, fallback: T = {} as T) {
  if (!value) return fallback
  try {
    return JSON.parse(decodeURIComponent(value))
  } catch {
    try {
      return JSON.parse(value)
    } catch {
      return fallback
    }
  }
}

export function decodeStringParameter(value?: string, fallback = '') {
  if (!value) return fallback
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}
